import { render, staticRenderFns } from "./topicCollectionList.vue?vue&type=template&id=6ef88702&scoped=true"
import script from "./topicCollectionList.vue?vue&type=script&lang=js"
export * from "./topicCollectionList.vue?vue&type=script&lang=js"
import style0 from "./topicCollectionList.vue?vue&type=style&index=0&id=6ef88702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef88702",
  null
  
)

export default component.exports